import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api/apiClient';

export type SimStatsPeriod = {
    period: string;
    days: number;
};

export type SimStatsSort = {
    field: string;
    direction?: 'ASC' | 'DESC';
};

export interface SimStatsFilters {
    season?: number;
    period?: string;
    // extend with additional filter fields as needed
    [key: string]: any;
}

export interface UseSimStatsOptions {
    leagueId: number | string | undefined;
    type: 'batting' | 'pitching';
    filters?: SimStatsFilters;
    page?: number;
    pageSize?: number;
    sortBy?: SimStatsSort;
    enabled?: boolean;
}

export interface SimStatsResponse<T = any> {
    rows: T[];
    total: number;
    page: number;
    pageSize: number;
}

export const useSimStats = <T = any>({
    leagueId,
    type,
    filters = {},
    page = 1,
    pageSize = 50,
    sortBy,
    enabled = true,
}: UseSimStatsOptions) => {
    return useQuery<SimStatsResponse<T>>({
        queryKey: ['simStats', type, leagueId, filters, page, pageSize, sortBy],
        queryFn: async () => {
            if (!leagueId) {
                throw new Error('League ID is required');
            }

            const endpoint =
                type === 'batting'
                    ? `/stats/get-sim-batting-stats/${leagueId}`
                    : `/stats/get-sim-pitching-stats/${leagueId}`;

            const res = await apiClient.post(endpoint, {
                filters,
                page,
                pageSize,
                sortBy,
            });

            return res.data as SimStatsResponse<T>;
        },
        enabled: enabled && !!leagueId,
        keepPreviousData: true,
    });
};

